export function Bar({ value, max, color, label }: { value: number; max: number; color: string; label: string }) {
  const pct = max > 0 ? Math.max(0, Math.min(100, (value / max) * 100)) : 0;
  return (
    <div class="bar"><div class="bar-fill" style={{ width: `${pct}%`, background: color }} /><span class="bar-label">{label}</span></div>
  );
}
